import React, { useState } from 'react';
import '../scss/Admin.scss';
import ManageCategories from './ManageCategories';
import AddProductForm from './AddProductForm';
import ManageProducts from './ManageProducts';
import ManageCampaigns from './ManageCampaigns';

const AdminPanel = () => {
  const [view, setView] = useState<'products' | 'categories' | 'campaigns' | 'addProduct'>('addProduct');

  return (
    <div className="admin-page">
      <div className="admin-header">
        <h1>Accordi Adminpanel</h1>
        <p>Administrativa funktioner för produkter och innehåll</p>
        <div className="admin-actions">
          <button className="admin-button" onClick={() => setView('campaigns')}>Hantera kampanjer</button>
          <button className="admin-button" onClick={() => setView('categories')}>Hantera kategorier</button>
          <button className="admin-button" onClick={() => setView('products')}>Hantera produkter</button>
          <button className="admin-button" onClick={() => setView('addProduct')}>Lägg till ny produkt</button>
          <button
            className="admin-button"
            onClick={() => window.open('/', '_blank')}
          >
            Öppna hemsidan
          </button>

        </div>
      </div>

      <div className="admin-content">
        {view === 'addProduct' && <AddProductForm />}
        {view === 'categories' && <ManageCategories />}
        {view === 'products' && <ManageProducts />}
        {view === 'campaigns' && <ManageCampaigns />}
      </div>
    </div>
  );
};

export default AdminPanel;
